import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function EngineeringIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-engineering",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1044:40728)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.631 5.137c-.777-2.85-4.818-2.85-5.596 0-.55 2.014-2.983 2.805-4.612 1.498-2.303-1.847-5.573.528-4.527 3.29.74 1.952-.765 4.023-2.85 3.923-2.95-.14-4.2 3.702-1.73 5.322 1.746 1.145 1.746 3.705 0 4.85-2.47 1.62-1.22 5.463 1.73 5.322 2.085-.1 3.59 1.97 2.85 3.923-1.046 2.762 2.223 5.137 4.527 3.29 1.629-1.307 4.063-.516 4.612 1.498.778 2.85 4.819 2.85 5.596 0 .55-2.014 2.984-2.805 4.613-1.498 2.303 1.847 5.572-.528 4.527-3.29-.74-1.952.765-4.023 2.85-3.923 2.95.14 4.199-3.702 1.73-5.322-1.746-1.145-1.746-3.705 0-4.85 2.469-1.62 1.22-5.463-1.73-5.322-2.085.1-3.59-1.97-2.85-3.924 1.045-2.761-2.224-5.136-4.527-3.289-1.629 1.307-4.063.516-4.613-1.498zm-2.944 22.518a5.896 5.896 0 100-11.791 5.896 5.896 0 000 11.791z",
    fill: "#1E6DEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.688,
    cy: 21.759,
    r: 10.184,
    stroke: "#85B3FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.58 36.916c.478-2.165 3.15-2.963 4.736-1.413a2.827 2.827 0 003.497.36c1.869-1.193 4.322.132 4.348 2.35a2.826 2.826 0 002.217 2.728c2.166.477 2.964 3.149 1.413 4.735a2.827 2.827 0 00-.36 3.497c1.194 1.87-.132 4.322-2.35 4.348a2.826 2.826 0 00-2.727 2.218c-.477 2.166-3.15 2.963-4.736 1.413a2.827 2.827 0 00-3.496-.36c-1.87 1.193-4.322-.132-4.348-2.35a2.827 2.827 0 00-2.218-2.727c-2.166-.478-2.963-3.15-1.413-4.736a2.827 2.827 0 00.36-3.497c-1.194-1.87.132-4.322 2.35-4.348a2.827 2.827 0 002.727-2.218z",
    fill: "#5C9BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.783,
    cy: 46.143,
    r: 4.824,
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1044:40728"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  }))));
}